<template lang="html">
  <section class="section" v-if="isLoggedIn && user">
    <div class="container">
      <h1 class="title has-text-secondary">Settings</h1>
      <div class="columns is-centered">
        <div class="column is-narrow">
          <b-menu>
            <b-menu-list label="General">
              <b-menu-item
                icon="account"
                label="User"
                :active="activeItem === 'user'"
                @click="activeItem = 'user'"
              />

              <b-menu-item
                icon="bell"
                label="Notifications"
                :active="activeItem === 'notifications'"
                @click="activeItem = 'notifications'"
              />

              <b-menu-item
                icon="shield-lock"
                label="Security"
                :active="activeItem === 'security'"
                @click="activeItem = 'security'"
              />

              <b-menu-item
                icon="cancel"
                label="Block"
                :active="activeItem === 'blocked'"
                @click="activeItem = 'blocked'"
              />

              <b-menu-item
                icon="account-remove"
                label="Deactivation"
                :active="activeItem === 'deactivation'"
                @click="activeItem = 'deactivation'"
              />
            </b-menu-list>
            <b-menu-list label="Privacy & Terms">
              <b-menu-item
                label="Privacy Policy"
                tag="router-link"
                to="/privacy-policy"
              ></b-menu-item>
              <b-menu-item
                label="Terms of Service"
                tag="router-link"
                to="/terms-of-service"
              ></b-menu-item>
              <b-menu-item label="Help & FAQ" tag="router-link" to="/faq"></b-menu-item>
            </b-menu-list>
          </b-menu>
        </div>

        <div class="column">
          <component :is="activeItem" :user="user"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin.js'
import { mapGetters } from 'vuex'

import Security from '@/views/Settings/Items/Security'
import User from '@/views/Settings/Items/User'
import Notifications from '@/views/Settings/Items/Notifications'
import Blocked from '@/views/Settings/Items/Blocked'
import Deactivation from '@/views/Settings/Items/Deactivation'

export default {
  mixins: [dateMixin],
  data () {
    return {
      user: null,
      activeItem: 'user'
    }
  },
  components: {
    user: User,
    security: Security,
    notifications: Notifications,
    deactivation: Deactivation,
    blocked: Blocked
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      currentUser: 'currentUser'
    })
  },
  watch: {
    currentUser (newValue, oldValue) {
      this.user = JSON.parse(JSON.stringify(newValue.attributes))
    }
  },
  methods: {
    success (message) {
      this.$buefy.toast.open({
        message: 'Modification saved',
        type: 'is-success'
      })
    }
  },
  mounted () {
    if (this.currentUser !== null && this.currentUser !== undefined) {
      this.user = JSON.parse(JSON.stringify(this.currentUser.attributes))
    }
  }
}
</script>

<style lang="scss" scoped></style>
